<template>
    <list-page icone="mdi-bank" titulo="Banco" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:corpo>

          <div class="cards-totalizadores-container mb-4">
            <v-card v-for="card in cardsTotalizadores" :key="card.chave" class="pa-3 totalizador-card" outlined :style="`background-color: ${card.corFundo}; border-color: ${card.corBorda};`">
              <div class="d-flex">
                <v-avatar size="28" :color="card.corIconeFundo" class="mr-3">
                  <v-icon small :color="card.corIcone">{{ card.icone }}</v-icon>
                </v-avatar>
                <div>
                  <div class="totalizador-titulo">{{ card.titulo }}</div>
                  <div class="totalizador-valor">{{ loadingTotalizadores || erroTotalizadores ? '-' : card.valor }}</div>
                  <div class="totalizador-subtitulo">{{ card.subtitulo }}</div>
                </div>
              </div>
            </v-card>
          </div>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
                  <template v-slot:[`item.actions`]="{ item }">

                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>

                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>

                  </template>

                  <template v-slot:[`item.situacao`]="{ item }">
                    {{item.situacaoStr}}
                  </template>

                </v-data-table>

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.nome }}</td>
                    <td>{{ item.gerente }}</td>
                    <td>{{ item.gerenteTelefone }}</td>
                    <td>{{ item.gerenteCelular }}</td>
                    <td>{{ item.gerenteEmail }}</td>
                    <td>{{ item.situacaoStr }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-banco v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>
<script>
import BancoService from '../../../core/services/financeiro/BancoService';
import Banco from '../../../core/domain/financeiro/Banco';
import ListPage from "@/components/shared/ListPage";

const totalizadoresPadrao = () => ({
  totalBancos: 0,
  totalBancosAtivos: 0,
  totalBancosInativos: 0
});

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Código', value: 'id', type: 'number' },
        { text: 'Nome', value: 'nome' },
        { text: 'Gerente', value: 'gerente' },
        { text: 'Telefone', value: 'gerenteTelefone' },
        { text: 'Celular', value: 'gerenteCelular' },
        { text: 'E-mail', value: 'gerenteEmail' },
        { text: 'Situação', value: 'situacao' }
      ],
      primeiraCarga: true,
      loadingTotalizadores: false,
      erroTotalizadores: false,
      listarRequestId: 0,
      totalizadores: totalizadoresPadrao()
    }),
    computed: {
      cardsTotalizadores(){
        return [
          {
            chave: 'total',
            titulo: 'Total',
            valor: this.totalizadores.totalBancos,
            subtitulo: 'Quantidade total filtrada',
            icone: 'mdi-bank-outline',
            corFundo: '#edf2f7',
            corBorda: '#d4dde8',
            corIconeFundo: '#dfe7f1',
            corIcone: '#3f5d7a'
          },
          {
            chave: 'ativos',
            titulo: 'Ativo',
            valor: this.totalizadores.totalBancosAtivos,
            subtitulo: 'Situação ativa',
            icone: 'mdi-check-circle-outline',
            corFundo: '#eaf6ef',
            corBorda: '#d3e8dc',
            corIconeFundo: '#dceddf',
            corIcone: '#2f6f4f'
          },
          {
            chave: 'inativos',
            titulo: 'Inativo',
            valor: this.totalizadores.totalBancosInativos,
            subtitulo: 'Situação inativa',
            icone: 'mdi-close-circle-outline',
            corFundo: '#fbebea',
            corBorda: '#efd9d7',
            corIconeFundo: '#f7dfdd',
            corIcone: '#9b4942'
          }
        ];
      }
    },
    created() {
      this.service = new BancoService();
    },
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    methods: {
      Listar(filter, include){
        const requestId = ++this.listarRequestId;

        this.loading = true;
        this.loadingTotalizadores = true;
        this.erroTotalizadores = false;

        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        this.service.Listar(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, filter, include)
          .then(
            res => {
              if(requestId !== this.listarRequestId)
                return;

              this.lista = res.data.items;
              this.totalLista = res.data.count;
            },
            err => {
              if(requestId === this.listarRequestId)
                this.$swal('Aviso', err.response ? err.response.data : err.message, 'error');
            }
          )
          .finally(() => {
            if(requestId === this.listarRequestId)
              this.loading = false;
          });

        this.service.Totalizadores(this.search, this.headers, filter, include)
          .then(
            res => {
              if(requestId !== this.listarRequestId)
                return;

              this.totalizadores = res.data;
            },
            err => {
              if(requestId !== this.listarRequestId)
                return;

              this.erroTotalizadores = true;
              this.$swal('Aviso', err.response ? err.response.data : err.message, 'error');
            }
          )
          .finally(() => {
            if(requestId === this.listarRequestId)
              this.loadingTotalizadores = false;
          });
      },
      Novo(){
        this.NovoCadastro(new Banco());
      },
      Editar(item){
        this.service.ObterPorId(item.id)
          .then(
            res =>{
              this.EditarCadastro(new Banco(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      }
    },
    mounted() {
      this.Listar()
    }
}
</script>
<style scoped>
.totalizador-card {
  border-width: 1px;
  border-style: solid;
  min-height: 108px;
  width: clamp(220px, 18vw, 280px);
}

.cards-totalizadores-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: clamp(10px, 1.2vw, 20px);
}

@media (max-width: 600px) {
  .totalizador-card {
    width: 100%;
  }
}

.totalizador-titulo {
  font-size: 12px;
  color: #5f6a77;
  font-weight: 600;
  line-height: 1.3;
}

.totalizador-valor {
  font-size: 30px;
  font-weight: 700;
  color: #202b37;
  line-height: 1.1;
}

.totalizador-subtitulo {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

</style>
